import { Core } from "@faire/design-tokens";
import styled, { css } from "styled-components";
export var AspectRatioPicture = styled.picture.withConfig({
    componentId: "sc-cfc8e345-0"
})([
    "display:flex;position:relative;height:0;flex-shrink:0;",
    " width:",
    ";padding-top:",
    ";img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:",
    ";object-position:center;}"
], function(param) {
    var hideBorder = param.$hideBorder;
    return hideBorder ? "" : css([
        "border:1px solid ",
        ";"
    ], Core.border.muted);
}, function(param) {
    var width = param.$width, height = param.$height, ratio = param.$ratio;
    if (width) {
        if (typeof width === "number") {
            return css([
                "",
                "px"
            ], width);
        }
        return width;
    }
    if (height) {
        if (typeof height === "number") {
            return css([
                "calc(",
                "px * ",
                ")"
            ], height, ratio);
        }
        return css([
            "calc(",
            " * ",
            ")"
        ], height, ratio);
    }
    throw new Error("neither width or height defined in AspectRatioPicture Component");
}, function(param) {
    var width = param.$width, height = param.$height, ratio = param.$ratio, hideBorder = param.$hideBorder;
    if (width) {
        if (typeof width === "number") {
            return css([
                "calc(",
                "px / ",
                " - ",
                ")"
            ], width, ratio, hideBorder ? "0px" : "2px");
        }
        return css([
            "calc(",
            " / ",
            " - ",
            ")"
        ], width, ratio, hideBorder ? "0px" : "2px");
    }
    if (height) {
        if (typeof height === "number") {
            return css([
                "",
                "px"
            ], height);
        }
        return height;
    }
    throw new Error("neither width or height defined in AspectRatioPicture Component");
}, function(param) {
    var objectFit = param.$objectFit;
    return objectFit || "cover";
});
